export function imageUrl(event, { width, height } = {}) {
    if (typeof event !== 'object') {
        return;
    }

    const src = event.image?.src;

    if (!src) {
        return;
    }

    if (!src) {
        console.warn("Image source is required");
    }

    const params = [];
    if (width) params.push(`width=${width}`);
    if (height) params.push(`height=${height}`);

    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `${src}${queryString}`;
}
